/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DialogTitle/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DialogTitle({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/BulkActions/Content/DialogTitle"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="DialogTitle.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-1Yprxq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-1Yprxq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-1Yprxq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-1Yprxq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Bulk actions on tasks"
 display="block"
 color={dtColorsNeutral500}
 weight="medium"
 textOverflow="ellipsis"
 whiteSpace="nowrap"
/>
</div>
{children}
</React.Fragment>)
}